import isCoupon from './is_coupon';

export const googleTagManager = (event, value) => {
  const NODE_ENV = process.env.NODE_ENV;
  if (NODE_ENV === 'production') {
    const { dataLayer } = window;
    const data = { event, ...value };
    dataLayer.push(data);
  }
}

export const postMembershipGoogleTagManager = (
  plan,
  membershipId,
  userId,
  locality,
  coupon,
  email,
  mobilePhone
) => {
  const trackManager = {
    productId: plan.id,
    productName: plan.name,
    orderID: membershipId,
    orderTotal: plan.displayPrice,
    pageCategory: 'order_complete',
    pageURL: window.location.href,
    accountNumber: null,
    userId,
    location: locality,
    coupon: isCoupon(coupon) ? { id: coupon.id, name: coupon.name } : false,
    email: email,
    mobilePhone: mobilePhone
  };
  googleTagManager('startMembership', trackManager);
}

export const postExistingMemberAddPatientGoogleTagManager = (
  plan,
  membershipId,
  userId,
  locality,
  coupon,
) => {
  const trackManager = {
    productId: plan.id,
    productName: plan.name,
    orderID: membershipId,
    orderTotal: plan.displayPrice,
    pageCategory: 'order_complete',
    pageURL: window.location.href,
    accountNumber: null,
    userId,
    location: locality,
    coupon: isCoupon(coupon) ? { id: coupon.id, name: coupon.name } : false,
  };
  googleTagManager('existingMemberAddPatientPaymentComplete', trackManager);
}

export const postIntroExamBooking = (
  email,
  firstName,
  lastName,
  mobilePhone
) => {
  const trackManager = {
    email: email,
    firstName: firstName,
    lastName: lastName,
    mobilePhone: mobilePhone
  };
  googleTagManager('introExamBooking', trackManager)
}